import commonStyles from '../styles/common.module.css'
import { Box, Link, Typography } from '@material-ui/core'

/**
 * Custon `NotFound` component declaration.
 * @return NotFound
 */
export default function NotFound(): JSX.Element {
  return (
    <div className={commonStyles.container}>
      <Typography variant="h3" component="h3">
        Upppss! 
      </Typography>
      <Typography variant="h6" component="h6" align='center'>
        No hemos encontrado la página que estas buscando, tal vez podrías:
      </Typography>
      
    <Box style={{display: 'flex', justifyContent: 'center', marginTop: '5vh'}}>
      <Link variant="subtitle1" href="/login" color="secondary" style={{marginRight: '10vw'}}>
        <Box mt={2} textAlign="center">
          Iniciar sesión
        </Box>
      </Link>
      <Link variant="subtitle1" href="/" color="secondary">
        <Box mt={2} textAlign="center">
          Ir al inicio
        </Box>
      </Link>
      </Box>
    </div>
  )
}